/**
 * render 所写的form 共用 属性和方法
 * @type {{data(): *, methods: {}}}
 */
export var renderFormMixins = {
  data: function data() {
    return {
      refName: 'refName'
    };
  },
  methods: {
    /**
     * 表单校验
     * @returns {Promise<any>}
     */
    formCheck: function formCheck() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$refs[_this.refName].validate(function (valid) {
          resolve(valid);
        });
      });
    },

    /**
     * 表单校验2
     * @returns {Promise<any>}
     */
    checkForm: function checkForm() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.$refs[_this2.refName].validate(function (valid) {
          resolve(valid);
        });
      });
    }
  },
  mounted: function mounted() {}
};